module.exports = __webpack_public_path__ + "media/images/leads_generation/illustration-data-294641e4262edc4561671df1581849f0.png";